import React, { useState, useEffect } from 'react';
import Logo from './Logo'
import NavItems from './NavItems';

function Navbar() {
  return (
    <header className='header'>
      <div className='container w-full max-w-full'>
        <Logo className="dosislite-logo"/>
        <div className='header-content no_has_navbar'>
          <NavbarMobile/>
          <div className='navbar-main'>
            <NavItems className="nav-main main-menu-horizontal"/>
          </div>
          <div className='navbar-col navbar-end'>
            <a href="#" className="menu-touch nav-right d-lg-none" onClick={(e) => SwitchNavigation()}>
              <div className="navbar-toggle">
                <span></span>
                <span></span>
                <span></span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </header>
  )
}

function SwitchNavigation() {
  const body = document.body; 
  const classNameForVisibleMenuTouch = "open-menutouch";

  if (body.classList.contains(classNameForVisibleMenuTouch)) {
    body.classList.remove(classNameForVisibleMenuTouch);
  } else {
    body.classList.add(classNameForVisibleMenuTouch);
  }
}

function NavbarMobile() {
  return (
    <div className='navbar-col navbar-left'>
      <a href='javascript:void(0)' className='navbar-touch'>
        <div className='navbar-toggle'>
          <span></span>
        </div>
      </a>
    </div>
  );
}

export default Navbar
